import { createLegalPageLoadData } from '../legalPageAssets';

export const ASSET_NAME = 'terms-of-service';

export const loadData = createLegalPageLoadData({
  assetName: ASSET_NAME,
  stateKey: 'termsOfService',
});
